import { Switch as DesignSystemSwitch } from '@noorden-insurtech/alba-design-system';
import type { ReactNode } from 'react';

export type SwitchProps = {
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
  /** Rótulo clicável, lido pelo leitor de tela. */
  label: ReactNode;
  disabled?: boolean;
};

/**
 * Liga/desliga. Envolve o `Switch` do design system, que está saindo: features
 * importam daqui, nunca do pacote.
 */
export function Switch({
  checked,
  onCheckedChange,
  label,
  disabled,
}: SwitchProps) {
  return (
    <DesignSystemSwitch.Root
      checked={checked}
      onCheckedChange={details => onCheckedChange(details.checked)}
      disabled={disabled}
    >
      <DesignSystemSwitch.Control>
        <DesignSystemSwitch.Thumb />
      </DesignSystemSwitch.Control>
      <DesignSystemSwitch.Label>{label}</DesignSystemSwitch.Label>
      <DesignSystemSwitch.HiddenInput />
    </DesignSystemSwitch.Root>
  );
}
